<i18n src="@/locales/views/organization/certifications/query_formats/list_certifications.yml" lang="yaml"></i18n>
<!-- <i18n src="@/locales/models/producer.yml" lang="yaml"></i18n> -->
<!-- <i18n src="@/locales/models/crop_field.yml" lang="yaml"></i18n> -->
<!-- <i18n src="@/locales/models/crop_field_certification.yml" lang="yaml"></i18n> -->
<template>
  <div class="mt-8 mb-8">
    <h1 class="page-title">{{ module_name }}</h1>
  </div>

  <template v-if="load_data_general">
    <div class="bg-white shadow overflow-hidden sm:rounded-md" >
      <ul role="list" class="divide-y divide-gray-200">
        <template v-for="certification in certifications" :key="certification.id">
          <li v-for="version in certification.certification_versions" :key="version.id">
            <div class="block hover:bg-gray-50 cursor-pointer" @click.prevent="goToShow(certification.id, version.id)">
              <div class="px-4 py-4 sm:px-6">
                <div class="flex items-center justify-between">
                  <p class="text-sm font-medium text-gray-900 truncate">
                    {{ certification.name }} - {{ version.name }}
                  </p>
                  <div class="ml-2 flex-shrink-0 flex">
                    <a class="link invisible sm:visible">
                      <i class="fa-solid fa-eye"></i>
                      <span class="space-icon"></span>{{ $t("labels.show_link") }}
                    </a>
                  </div>
                </div>
              </div>
            </div>
          </li>
        </template>
      </ul>
    </div>
  </template>

  <loading-message v-else />

</template>

<script>
import Requester from "@/views/organization/requesters/certifications/query_formats/list_certifications.js";

export default {
  name: "AECertificationsQueryFormatsListCertifications",
  data() {
    return {
      load_data_general: false,
      certifications: [],
    };
  },
  props: { organization_id: { required: true } },
  created() {
    this.checkIfAuthenticated().then(() =>
      this.checkIfAuthorized({
        role: this.$route.meta.role,
        permission: this.$route.meta.permission,
        entity: {
          organization_id: this.organization_id,
        },
      }).then(() => this.loadData())
    );
  },
  methods: {
    loadData: async function () {
      await this.fetchCertifications();
      this.load_data_general = true;
    },
    fetchCertifications: async function () {
      let response = await Requester.fetchCertifications(this.organization_id);

      this.certifications = response.data;
    },
    goToShow(certification_id, version_id) {
      console.log('goTo:', certification_id, version_id);
      this.$router.push({
        name: this.routeName("list_formats"),
        params: {
          organizationId: this.organization_id,
          certificationId: certification_id,
          certificationVersionId: version_id
        },
      });
    },
  },
};
</script>
